<template lang="html">
    <div class="feature field" data-group="1" :class="{ 'edit': editing, 'view' : !editing }">
        <!-- create custom feature, on product -->
        <!-- #region - edit -->
        <template v-if="editing">
            <div class="label">
                <v-text-field v-model="buffer.label" placeholder="Libellé" :rules="rules.label" required autofocus></v-text-field>
            </div>
            <div class="value">
                <v-text-field v-model="buffer.value" placeholder="Valeur"></v-text-field>
            </div>
            <div class="actions">
                <v-btn icon small :loading="loading" v-if="model.id != undefined" @click.stop="$eventHub.$emit('open-modal', Delete, { feature: model })">
                    <v-icon color="error">delete</v-icon>
                </v-btn>
                <v-btn icon small @click.stop="cancel">
                    <v-icon color="error">close</v-icon>
                </v-btn>
                <v-btn icon small :loading="loading" @click.stop="validate">
                    <v-icon color="success">check</v-icon>
                </v-btn>
            </div>
        </template>
        <!-- #endregion -->

        <!-- #region - view -->
        <template v-else>
            <div class="label">
                {{ model.label }}
            </div>
            <div class="value">
                {{ model.value }}
            </div>
            <div class="actions">
                <v-btn icon small v-if="model.is_exportable" @click="setVisibility(false)">
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-btn icon small v-else @click="setVisibility(true)">
                    <v-icon>mdi-eye-off</v-icon>
                </v-btn>
                <v-btn icon small @click="edit">
                    <v-icon>mode_edit</v-icon>
                </v-btn>
            </div>
        </template>
        <!-- #endregion -->

    </div>
</template>


<script>
    import Delete from './Delete'

    export default {
        props: {
            index: {
                required:   true,
                type:       Number
            }
        },

        data() {
            return {
                model:      {},
                buffer:     {},
                editing:    false,
                loading:    false,

                rules: {
                    label: [
                        (v) => !!v || 'Libellé obligatoire',
                    ]
                },

                Delete
            }
        },

        methods: {
            cancel() {
                if(this.model.id) {
                    this.buffer     = {}
                    this.editing    = false

                } else {
                    this.$store.dispatch('removeSingleData', { key: 'features[' + this.index + ']' })
                }
            },

            validate() {
                // when modify a prevouisly created feature
                if(this.buffer.id) {
                    delete this.buffer.id

                    this.axios.put(`/api/features/${this.model.id}`, this.buffer)
                        .then(res   => {
                            this.$store.dispatch('updateSingleData', { key: 'features[' + this.index + ']', value: res.data })
                            this.model      = res.data
                            this.editing    = false
                        })
                        .catch(err  => console.log(err.response.data))

                } else {
                    // create a new feature
                    this.axios.post('/api/features', this.buffer)
                        .then(res   => {
                            this.$store.dispatch('updateSingleData', { key: 'features[' + this.index + ']', value: res.data })
                            this.model      = res.data
                            this.editing    = false
                        })
                        .catch(err  => console.log(err.response.data))
                }
            },
            // set the visibility in the export of this feature
            setVisibility(is_visible) {
                this.axios.put(`/api/features/${this.model.id}`, { is_exportable: is_visible ? 1 : 0 })
                    .then(res   => {
                        this.$store.dispatch('updateSingleData', { key: 'features[' + this.index + ']', value: res.data })
                        this.model      = res.data
                    })
                    .catch(err  => console.log(err.response.data))
            },

            edit() {
                this.buffer     = Object.assign({}, this.model)
                this.editing    = true
            },
        },

        created() {
            if(Array.isArray(this.$store.state.single.data.features)) {
                this.model      = this.$store.state.single.data.features[this.index]

                if(this.model.id == undefined) {
                    this.edit()
                }
            }
        }
    }
</script>


<style lang="stylus" scoped>
    @require '../../../../assets/css/variables'

    div.feature {
        display: flex
        align-items: center
        height: 5.5rem
        padding: 0 0 0.5rem

        &.edit {
            div.label {
                margin-right: 2rem
            }

            div.value {
                margin-right: 2rem
            }

            div.actions {

            }
        }

        &.view {
            div.label {

            }

            div.value {

            }

            div.actions {
                button {
                    color: #ABB4D0
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/views/products/single/features/Feature.vue